<div [hidden]="!isCCEnabled" class="heartland-payment-type">
  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label for="credit-card-card-number">Card Number:</label>
        <div id="credit-card-card-holder" [hidden]="true"></div>
        <div id="credit-card-card-number"></div>
      </div>
    </div>
  </div>
  <div class="row row-mobile">
    <div class="col-md-6">
      <div class="form-group">
        <label for="credit-card-card-expiration">Card Expiration:</label>
        <div id="credit-card-card-expiration"></div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label for="credit-card-card-cvv">Card CVV:</label>
        <div id="credit-card-card-cvv"></div>
      </div>
    </div>
  </div>
</div>

<div class="content content-forbidden" *ngIf="!isCCEnabled">
  <div class="dv-empty dv-empty-403 p-3">
    <p>
      Credit card is not activated in you location. Please contact your
      administrator
    </p>
  </div>
</div>
